<template>
    <!-- contents -->
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <h2 class="pg_title">{{ pageTitle }}</h2>
            <!-- breadcrumbs -->
            <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            <!-- //contents_head -->
            <div :style="{ display: mode === 'list' ? 'block' : 'none' }">
                <!-- srchTop_wrap -->
                <div class="srchTop_wrap">
                    <article class="srch_basic">
                        <div class="srch_grup">
                            <ul class="w100">
                                <li class="tit_150">{{$t('FIELD.COUNTRY.NAME')}}</li>
                                <li data-input-type="select" class="w100-150">
                                    <fieldset class="ui_fieldset set_3">
                                        <div>
                                            <select class="slt_white w100p" v-model="rhqCd" disabled>
                                                <option v-for="code in rhqCdList" :key="code.code" :value="code.code">{{code.codeName}}</option>
                                            </select>
                                        </div>
                                        <div>
                                            <select class="slt_white w100p" v-model="corpNo" @change="changeCorpNo" :disabled="corpCd != 'C100'">
                                                <option value="">{{$t('FIELD.EUR.SELECT.CORPORATION')}}</option>
                                                <option v-for="code in corpNoList" :key="code.code" :value="code.code">{{code.codeName}}</option>
                                            </select>
                                        </div>
                                        <div>
                                            <select class="slt_white w100p" v-model="countryCd" @change="changeCountryCd">
                                                <option value="">{{$t('FIELD.EUR.SELECT.COUNTRY')}}</option>
                                                <option v-for="code in countryCdList" :key="code.CODE" :value="code.CODE">{{code.CODE_NM}}</option>
                                            </select>
                                        </div>
                                    </fieldset>
                                </li>
                            </ul>
                            <ul class="w50">
                                <li class="tit_150">{{$t('FIELD.EUR.FIRST.APPROVER')}}</li>
                                <li data-input-type="input" class="w100-150">
                                    <span class="clearable">
                                        <input type="text" class="text_input w100" v-model="aprFrstUser" @keyup.enter="onSearch()" v-clearable />
                                        <i class="clearable_clear">X</i>
                                    </span>
                                </li>
                            </ul>
                            <ul class="w50">
                                <li class="tit_150">{{$t('FIELD.EUR.SECOND.APPROVER')}}</li>
                                <li data-input-type="input" class="w100-150">
                                    <span class="clearable">
                                        <input type="text" class="text_input w100" v-model="aprScndUser" @keyup.enter="onSearch()" v-clearable />
                                        <i class="clearable_clear">X</i>
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <div class="srch_grupR_bottom">
                            <span class="btn">
                                <a href="JavaScript:" class="btn_srch" @click="onSearch">{{$t('BUTTON.GLOBAL.SEARCH')}}</a>
                            </span>
                        </div>
                    </article>
                </div>
                <!-- Grid -->
                <div class="grid_wrap">
                    <!-- Count -->
                    <div class="grid_total">{{$t('TITLE.TOTAL.COUNT')}} : <em>{{totalCount}}</em></div>
                    <!-- Grid -->
                    <table class="data_table_ty2">
                        <colgroup>
                            <col width="*">
                            <col width="30%">
                            <col width="30%">
                            <col width="12%">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>{{$t('FIELD.COUNTRY.NAME')}}</th>
                                <th>{{$t('FIELD.EUR.FIRST.APPROVER')}}</th>
                                <th>{{$t('FIELD.EUR.SECOND.APPROVER')}}</th>
                                <th>{{$t('FIELD.GLOBAL.CREATE')}}/{{$t('FIELD.GLOBAL.MODIFY')}}</th>
                            </tr>
                        </thead>
                        <tbody class="text_center">
                            <tr v-for="data in valuesByCountries" :key="data.COUNTRY_CD">
                                <td class="text-left">{{data.COUNTRY_NM}}</td>
                                <td><span v-if="data.APR_FRST_USER">{{data.APR_FRST_USER_ID}} ({{data.APR_FRST_USER_NM}})</span></td>
                                <td>
                                    <span v-if="data.APR_SCND_USER">{{data.APR_SCND_USER_ID}} ({{data.APR_SCND_USER_NM}})</span>
                                    <span v-else-if="data.APR_FRST_USER_ID && !data.APR_SCND_USER">N/A</span>
                                </td>
                                <td><a href="JavaScript:" title="" class="btn_ss_white" @click="modefySettings(data)">{{$t('BUTTON.GLOBAL.EDIT')}}</a></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div style="margin-top:10px;">
                    <span style="color:red">
                    * NOTE : Approvers in the following list can also proceed with approval through Knox Approval
                    </span>
                </div>
            </div>
            <approver-detail v-if="mode == 'view'" :pParams="params"></approver-detail>
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import $ from 'jquery';
import qs from 'query-string';
import Vue from 'vue';
import api from '@/service';
import axios from 'axios';
import store from '@/vuex/store';
import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';
import { EventBus } from '@/utils/EventBus';
import { SDLUtil } from '@/utils';
import { mapGetters } from 'vuex';
import ApproverDetail from './ApproverByCountryDetail';

export default {
    name: 'EurApproverCountry',
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'approver-detail': ApproverDetail
    },
    computed: {
        ...mapGetters({
            corpCd: 'getCorpCd',
            loginRhq: 'getLoginRhq',
            loginNo: 'getLoginNo'
        })
    },
    data() {
        return {
            mode: 'list',
            pageTitle: '',
            totalCount: 0,
            valuesByCountries: [],
            rhqCd: '',
            corpNo: '',
            countryCd: '',
            paramCountryCd: '',
            rhqCdList: [],
            corpNoList: [],
            countryCdList: [],
            aprFrstUser: '',
            aprScndUser: '',
            params: {}
        };
    },
    methods: {
        onSearch() {
            SDLUtil.showLoadingBar(true);
            let searchParams = { rhqCd: this.rhqCd, corpNo: this.corpNo, countryCd: this.countryCd
                               , aprFrstUser: this.aprFrstUser , aprScndUser: this.aprScndUser };
            const url = `${SDLUtil.API_URL}/basis/eur/getSetValuesByCountries.skp`;
            return axios
                .post(url, qs.stringify(searchParams))
                .then(resp => {
                    this.valuesByCountries = resp.data.rows;
                    this.totalCount = this.valuesByCountries.length;

                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    SDLUtil.showLoadingBar(false);
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                });
        },
        async getCommonCodeList(v) {
            const codeResp = await api.getCommonCodeList(v);
            return codeResp;
        },
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.loginNo);
            return codeResp;
        },
        getRhqCdList() {
            this.getCodeComboList(this.loginNo, 'RHQ_AUTH_ACCESS_CD').then(data => {
                this.rhqCdList = data;
                this.getCorpNoList();
            });
        },
        changeCorpNo() {
            if (this.corpNo == '') { this.countryCdList = []; this.countryCd = ''; }
            else                   this.getCountryCdList();
        },
        getCorpNoList() {
            this.getCodeComboList(this.rhqCd, 'SUB_AUTH_ACCESS_CD').then(data => {
                let corpNo = this.corpNo;
                this.corpNoList = data;
                this.getCountryCdList();
            });
        },
        changeCountryCd() {
            if (this.countryCd == '') this.valuesByCountries = [];
            else                      this.search();
        },
        async getCountryCdList() {
//            SDLUtil.showLoadingBar(true);
            return axios
                .post(
                    `${SDLUtil.API_URL}/noauth/eur/getNationLangCodes.skp`,
                    qs.stringify({ groupCd: 'N', corpNo: this.corpNo })
                ).then(resp => {
//                    SDLUtil.showLoadingBar(false);
                    this.countryCdList = resp.data.rows;
                    if (this.countryCdList.length == 1) this.countryCd = this.countryCdList[0].CODE;
                    else                                this.countryCd = '';
                })
                .catch(err => {
//                    SDLUtil.showLoadingBar(false);
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                });
        },
        modefySettings(data) {
//            this.paramcountryCd = data.COUNTRY_CD;
            this.params = data;
            this.mode = 'view';
//            const pathUrl = `${SDLUtil.WEB_CONTEXT_PATH}/erp/adminSettingDetail`;
//            return this.$router.push({ path: pathUrl, query: {countryCd: data.COUNTRY_CD}});
        },
        goListBack(data) {
            this.mode = 'list';
            this.onSearch();
        }
    },
    created() {
        EventBus.$on('goApproverList', this.goListBack);
    },
    beforeDestroy() {
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
        EventBus.$off('goApproverList');
    },
    mounted() {
        this.rhqCd = this.loginRhq;
        this.corpNo = this.corpCd;

        this.getRhqCdList();
        SDLUtil.showLoadingBar(true);
        setTimeout(() => {
            this.onSearch();
        }, 400);
    },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/admin/ApproverByCountryList.vue